import { theme } from '@prophecy/theme';

import { UsageCategoryKey } from './types';

export const CATEGORY_COLOR: Record<UsageCategoryKey, string> = {
  data: theme.colors.blueDark600,
  ai: theme.colors.orangeDark400,
  infrastructure: theme.colors.blueLight400
};
